"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("../../commons/Constants");
const global_1 = require("../../commons/global");
const Cesium = window.Cesium;
/*
    This shape maker helper class uses Cesium specific entities and API's
*/
class ShapeMaker {
    constructor(mapService, mapHelper, entityHelper) {
        this.mapService = mapService;
        this.mapHelper = mapHelper;
        this.entityHelper = entityHelper;
        this.debug = Constants_1.Constants.debug_off;
        // currently selected point
        this.selectedShape = null;
        // currently selected shape
        this.selectedPoint = null;
        // entity group (shape) relationship
        this.shape_entities = null;
        // copy of Annotation
        this.annotation = null;
        // handle for point delete
        this.deleteEntity = null;
        // handles for adding points
        this.addHandles = null;
        // draw a ghostline when dragging handlers around
        this.ghostline = { id: null, entity: null, positions: null };
        // ghost position
        this.ghostpos = null;
        // ghostlines have one or two labels (p1 to p2, and p2 to p3)
        this.ghostlabelOne = null;
        this.ghostlabelTwo = null;
        // mouse moving counter (to determine if it's clicks or moves)
        this.mouseDragMovements = 0;
        // are we showing ghostlines? (default for most)
        this.useGhostlines = true;
        this.inFlight = false;
        this.checkCache = null;
        // what entity belongs to what shape?
        this.shape_entities = new Map();
        // console.log ( "shape-maker CONSTRUCTOR", this);
    }
    // finders for shapes and points
    loadShapes(a) {
        // copy over local reference
        this.annotation = a;
        // type of annotation
        const type = a['annotationMode'];
        // annotation reference
        let annotationRef = a ? (a['id'] ? a['id'] : 0) : null;
        // our shapes
        const shapes = a['shapes'] ? a['shapes'] : [];
        // local reference to avoid 'this' spaghetti
        const helper = this.entityHelper;
        if (this.debug) {
            console.log('%c shape_maker.service %c loadShapes()', Constants_1.Constants._orange, Constants_1.Constants._green, a);
        }
        // Pin?
        if (type === global_1.AnnotationType.poi) {
            // No support yet, done through addPlottable()
            // All else?
        }
        else {
            let shape_idx = -1;
            // for each shape
            shapes.forEach(function (current_shape) {
                shape_idx++;
                let shape_group = [];
                let point_idx = -1;
                current_shape.points.forEach((point) => {
                    point_idx++;
                    let props = {
                        shapeRef: shape_idx,
                        pointRef: point_idx,
                        entityRef: current_shape.entityRef,
                        coord: point['coords']
                    };
                    // create handles
                    let _obj = helper.addEntity(global_1.AnnotationType.handle, props, a, 'shape-maker-' + annotationRef);
                    // if ( this.debug ) { console.log ( '%c shape_maker.service %c loadShapes()', Constants._orange, Constants._green, shape_idx, point_idx, props, _obj );}
                    // what shape has what entities?
                    shape_group.push(_obj);
                });
                this.shape_entities.set(shape_idx, shape_group);
            }, this);
        }
        if (this.debug) {
            console.log(' @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ ');
            console.log('loadShapes() entities created', this.shape_entities);
            console.log(' @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ ');
        }
        // return shapes;
    }
    selectPoint(shape = 0, point = 0) {
        if (this.selectedPoint !== null && this.selectedPoint !== point) {
            this.unselectPoint();
        }
        // console.log ( 'shapeMaker.helper :: selectPoint ('+shape+','+point+') shapeGroup', this.shape_entities.get ( shape ) );
        let shapeGroup = null;
        if (shapeGroup = this.shape_entities.get(shape)) {
            shapeGroup.forEach((item) => {
                // get the properties of the handle we just pulled on
                let props = this.entityHelper.getEntityProperties(item);
                // console.log ( 'shapeMaker.helper :: selectPoint ('+shape+','+point+') props', props);
                if (props.pointRef == point) {
                    let _obj = this.entityHelper.getEntity(item);
                    if (_obj) {
                        _obj.point.pixelSize = global_1.AnnotationStyle.dotSelectedSize;
                        _obj.point.color = global_1.AnnotationStyle.dotSelectedColor;
                        _obj.point.outlineWidth = global_1.AnnotationStyle.dotSelectedOutlineSize;
                        _obj.point.outlineColor = global_1.AnnotationStyle.dotSelectedOutlineColor;
                        _obj.point.disableDepthTestDistance = 1500.0;
                        // create a delete icon
                        this.deleteEntity = this.entityHelper.addEntity(global_1.AnnotationType.deletehandle, {
                            shapeRef: shape,
                            pointRef: point,
                            coord: _obj.position
                        }, this.annotation, 'shape-maker-delete');
                    }
                    if (this.debug) {
                        console.log('shapeMaker.helper :: selectPoint (' + shape + ',' + point + ')', item, props, _obj);
                    }
                }
            });
            this.selectedShape = shape;
        }
        this.selectedPoint = point;
        return this.selectedPoint;
    }
    unselectPoint() {
        if (this.selectedPoint !== null) {
            let shapeGroup = null;
            if (shapeGroup = this.shape_entities.get(this.selectedShape)) {
                shapeGroup.forEach((item) => {
                    // get the properties of the handle we just pulled on
                    let props = this.entityHelper.getEntityProperties(item);
                    if (props.pointRef == this.selectedPoint) {
                        let _obj = this.entityHelper.getEntity(item);
                        if (_obj) {
                            _obj.point.pixelSize = global_1.AnnotationStyle.dotNormalSize;
                            _obj.point.color = global_1.AnnotationStyle.dotNormalColor;
                            _obj.point.outlineWidth = global_1.AnnotationStyle.dotNormalOutlineSize;
                            _obj.point.outlineColor = global_1.AnnotationStyle.dotNormalOutlineColor;
                        }
                    }
                });
            }
            // console.log ( 'shapeMaker.helper :: unselectPoint()', this.selectedPoint, shapeGroup);
            this.selectedPoint = null;
        }
        if (this.deleteEntity) {
            // remove our delete icon
            this.entityHelper.destroyEntity(this.deleteEntity);
            this.deleteEntity = null;
        }
        return this.selectedPoint;
    }
    addEntityToShape(e, shape = 0) {
        let shapeGroup = this.shape_entities.get(shape);
        if (shapeGroup && shapeGroup.length) {
            shapeGroup.push(e);
            this.shape_entities.set(shape, shapeGroup);
        }
    }
    // select a shape (group of entities)
    //   @shape: what shape in the annotation we're selecting (0 is default)
    //   @shapes: our shape object. If passed in, manipulate the shape object with the selection
    selectShape(shape = 0, shapes = null) {
        if (this.debug) {
            console.log('%c shape_maker.service %c selectShape (' + shape + ')', Constants_1.Constants._orange, Constants_1.Constants._green, shape, this.selectedShape, shapes);
        }
        if (this.selectedShape == shape) {
            return shape;
        }
        if (this.selectedShape !== null && this.selectedShape !== shape) {
            this.unselectShape(shapes);
        }
        let shapeGroup = null;
        if (shapeGroup = this.shape_entities.get(shape)) {
            // if we're to manipulate the shapes object
            if (shapes && shapes[shape]) {
                shapes[shape].showOptions = true;
            }
            // our handles-coord to add-handle LUT
            this.addHandles = new Map();
            let last = null;
            shapeGroup.forEach((item) => {
                let _obj = this.entityHelper.getEntity(item);
                // if ( this.debug ) { console.log ( '%c shape_maker.service %c selectShape ('+shape+') _obj', Constants._orange, Constants._green, _obj, shapeGroup );}
                if (_obj) {
                    // here's our handle
                    _obj.point.pixelSize = global_1.AnnotationStyle.dotNormalSize;
                    _obj.point.color = global_1.AnnotationStyle.dotNormalColor;
                    _obj.point.outlineWidth = global_1.AnnotationStyle.dotNormalOutlineSize;
                    _obj.point.outlineColor = global_1.AnnotationStyle.dotNormalOutlineColor;
                    // create an add-handle between this handle and the next
                    let pr = this.entityHelper.getEntityProperties(item);
                    let o = { from: pr.pointRef, fromPosition: _obj.position, to: pr.pointRef + 1, toPosition: null, calc: null };
                    last = pr.pointRef;
                    // if ( this.debug ) { console.log ( '%c shape_maker.service %c selectShape ('+shape+') _obj2', Constants._orange, Constants._green, pr, o, last );}
                    this.addHandles.set(pr.pointRef, o);
                }
            });
            // find all the right positions for our line middle-points
            for (const [point, o] of this.addHandles.entries()) {
                if (point == last) {
                    o.to = 0;
                }
                let next = this.addHandles.get(o.to);
                o.toPosition = next.fromPosition;
                this.addHandles.set(point, o);
            }
            if (this.debug) {
                console.log('%c shape_maker.service %c selectShape (' + shape + ') -> addHandle', Constants_1.Constants._orange, shape);
            }
            this.createAddHandles(shape, shapes);
            this.selectedShape = shape;
        }
        if (this.debug) {
            console.log('%c shape_maker.service %c selectShape (' + shape + ') END', Constants_1.Constants._orange, Constants_1.Constants._green, shapeGroup);
        }
        return this.selectedShape;
    }
    // unselect a shape (group of entities)
    unselectShape(shapes = null) {
        if (this.debug) {
            console.log('%c shape_maker.service %c unselectShape ()', Constants_1.Constants._orange, Constants_1.Constants._green, shapes);
        }
        let shapeGroup = null;
        if (this.selectedShape !== null) {
            if (shapeGroup = this.shape_entities.get(this.selectedShape)) {
                shapeGroup.forEach((item) => {
                    let _obj = this.entityHelper.getEntity(item);
                    if (_obj) {
                        _obj.point.pixelSize = global_1.AnnotationStyle.dotSize;
                        _obj.point.color = global_1.AnnotationStyle.dotColor;
                        _obj.point.outlineWidth = global_1.AnnotationStyle.dotOutlineSize;
                        _obj.point.outlineColor = global_1.AnnotationStyle.dotOutlineColor;
                    }
                });
            }
            this.deleteAddHandles();
            this.selectedShape = null;
        }
        // if we're to manipulate the shapes object, clear all showOptions
        if (shapes) {
            for (let n = 0; n < shapes.length; n++) {
                if (shapes[n]) {
                    shapes[n].showOptions = false;
                }
            }
        }
        if (this.debug) {
            console.log('%c shape_maker.service %c unselectShape() END', Constants_1.Constants._orange, Constants_1.Constants._green, shapeGroup, this.selectedShape);
        }
        return this.selectedShape;
    }
    createAddHandles(shape = 0, shapes = null) {
        // type of annotation
        const type = this.annotation['annotationMode'];
        let totalLength = 0;
        let entityRef = shapes[shape].entityRef;
        if (this.debug) {
            console.log('%c shape_maker.service %c createAddHandles()', Constants_1.Constants._orange, Constants_1.Constants._green, shape, shapes, type, entityRef);
        }
        if (this.addHandles && shapes[shape].points.length > 1) {
            let precission = 2;
            if (this.annotation && this.annotation.project && this.annotation.project['number_precission']) {
                precission = this.annotation.project['number_precission'];
            }
            for (const [point, o] of this.addHandles.entries()) {
                // console.log ( '%c shape=['+shape+'] point=['+point+'] ', Constants._green, o);
                if (o.fromPosition && o.toPosition)
                    o.calc = this.mapHelper.calculateLineInformation(o.fromPosition._value, o.toPosition._value);
                // if there's a next point AND we're not a line
                // or we're a multi-poi (then we don't need them)
                if ((type == global_1.AnnotationType.line && !this.addHandles.get(point + 1)) || type == global_1.AnnotationType.multipoi) {
                    // ignore the last add-handle for lines
                }
                else {
                    if (o.calc && o.calc.midpoint) {
                        o.handle = this.entityHelper.addEntity(global_1.AnnotationType.addhandle, {
                            shapeRef: shape,
                            pointRef: point,
                            coord: o.calc.midpoint,
                            entityRef: entityRef,
                        }, this.annotation, 'shape-maker-addhandles');
                        // if calculations exists
                        if (o.calc.length) {
                            totalLength += o.calc.length;
                            o.calc['precission'] = precission;
                            let e = this.entityHelper.getEntity(o.handle);
                            e.label.showBackground = true;
                            e.label.show = this.annotation['showLabels'];
                            e.label.text = this.createSimpleCalculatedText(o.calc);
                        }
                        shapes[shape].points[point]['calc'] = o.calc;
                    }
                }
            }
        }
        // just in case there's no calc ... (for the whole shape, not for each point ...)
        if (!shapes[shape]['calc']) {
            shapes[shape]['calc'] = {};
        }
        shapes[shape].calc.length = totalLength;
        shapes[shape].calc.centroid = this.mapHelper.calculateCentroid(this.getShapePositions(shape, shapes));
    }
    createSimpleCalculatedText(calc) {
        let p = calc['precission'];
        return this.mapHelper.getLocalisedValue(calc.length, this.annotation);
    }
    createCalculatedText(calc) {
        let p = calc['precission'];
        return 'Length:  ' + this.mapHelper.getLocalisedValue(calc.length, this.annotation) + '\n'
            + 'Length hor:  ' + this.mapHelper.getLocalisedValue(calc.lengthHorizontal, this.annotation) + '\n'
            + 'Height diff:  ' + this.mapHelper.getLocalisedValue(calc.slopeVertical, this.annotation) + '\n'
            + 'Azimuth:  ' + calc.azimuth.toFixed(2) + ' deg\n'
            + 'Slope:  ' + calc.slopePercent.toFixed(p) + '%';
    }
    deleteAddHandles() {
        if (this.addHandles) {
            for (const [point, o] of this.addHandles.entries()) {
                if (o.handle) {
                    this.entityHelper.destroyEntity(o.handle);
                    this.addHandles.delete(point);
                }
            }
        }
        // tough reset
        this.addHandles = new Map();
    }
    getAddhandleLabels() {
        return this.addHandles.entries();
    }
    turnHandleLabelsOff() {
        if (this.addHandles) {
            //console.log ( '%c shape_maker.service %c turnHandleLabelsOff()', Constants._orange, Constants._green );
            for (const [point, o] of this.addHandles.entries()) {
                if (o.handle) {
                    let e = this.entityHelper.getEntity(o.handle);
                    e.label.show = false;
                }
            }
        }
    }
    turnHandleLabelsOn() {
        if (this.addHandles) {
            //console.log ( '%c shape_maker.service %c turnHandleLabelsOn()', Constants._orange, Constants._green );
            for (const [point, o] of this.addHandles.entries()) {
                if (o.handle) {
                    let e = this.entityHelper.getEntity(o.handle);
                    e.label.show = true;
                }
            }
        }
    }
    turnHandleLabelsBackgroundOff() {
        if (this.addHandles) {
            //console.log ( '%c shape_maker.service %c turnHandleLabelsBackgroundOff()', Constants._orange, Constants._green );
            for (const [point, o] of this.addHandles.entries()) {
                if (o.handle) {
                    let e = this.entityHelper.getEntity(o.handle);
                    e.label.showBackground = false;
                }
            }
        }
    }
    turnHandleLabelOff(n) {
        // console.log ( "off", n, this.addHandles.get(n));
        if (this.addHandles && this.addHandles.has(n)) {
            let h = this.addHandles.get(n);
            if (h.handle) {
                let e = this.entityHelper.getEntity(h.handle);
                e.label.show = false;
            }
        }
    }
    turnHandleLabelsBackgroundOn() {
        if (this.addHandles) {
            //console.log ( '%c shape_maker.service %c turnHandleLabelsBackgroundOn()', Constants._orange, Constants._green );
            for (const [point, o] of this.addHandles.entries()) {
                if (o.handle) {
                    let e = this.entityHelper.getEntity(o.handle);
                    e.label.showBackground = true;
                }
            }
        }
    }
    // returns an array of all the positions of a shape
    getPositionsFromHandles(shape = 0) {
        let coords = [];
        let shapeGroup = null;
        if (shapeGroup = this.shape_entities.get(shape)) {
            shapeGroup.forEach((item) => {
                let _obj = this.entityHelper.getEntity(item);
                if (_obj && _obj.position && _obj.position._value) {
                    coords.push(_obj.position._value);
                }
            });
        }
        return coords;
    }
    getShapePositions(shape = 0, shapes = null) {
        if (!shapes[shape]) {
            return null;
        }
        return shapes[shape].points.map(p => p.coords);
    }
    getShapeAsPositions(shape, shapes) {
        let ret = [];
        let arr = shapes[shape].points;
        // console.log ( '%c QQQ', Constants._yellow, shape, shapes );
        for (let n = 0; n < arr.length; n++) {
            ret.push(arr[n].coords);
            // console.log ( '%c Q---', Constants._yellow, arr[n], arr[n]['coords'], arr[n].coords );
        }
        return ret;
    }
    updateShapesPositions(shapes, shape, positions) {
        let shape_idx = -1;
        // for each shape
        shapes.forEach(function (current_shape) {
            shape_idx++;
            if (shape_idx == shape) {
                let point_idx = -1;
                current_shape.points.forEach((point) => {
                    point_idx++;
                    point['coords'] = positions[point_idx];
                });
            }
        }, this);
        if (this.debug) {
            console.log('%c updateShapesPosition() === ', Constants_1.Constants._green, shapes);
        }
        return shapes;
    }
    destroy(a) {
        let annotationRef = a ? (a['id'] ? a['id'] : 0) : null;
        if (this.debug) {
            console.log('%c shape_maker.service %c destroy()', Constants_1.Constants._orange, Constants_1.Constants._green, annotationRef, a);
        }
        this.deleteAddHandles();
        this.unselectPoint();
        this.unselectShape();
        this.dragHandleEnd();
        this.ghostlineEnd();
        if (a && annotationRef !== null) {
            this.entityHelper.destroyEntitiesByCaller('shape-maker-' + annotationRef);
        }
        // reset the list of entities
        this.shape_entities = new Map();
    }
    dragHandleStart(checkedPosition, useGhostlines = true) {
        // set current state of using ghostlines
        this.useGhostlines = useGhostlines;
        // create a temporary cache of the object (as we don't want to use it before we're in flight / moving the mouse)
        this.checkCache = checkedPosition;
        if (this.debug) {
            console.log('mouse.drag START ###########################################', this.inFlight);
        }
    }
    dragHandleEnd(checkedPosition = null) {
        // make sure to not be flying
        this.inFlight = false;
        this.mouseDragMovements = 0;
        if (this.debug) {
            console.log('mouse.drag END ###########################################', this.inFlight);
        }
        if (!checkedPosition) {
            if (this.checkCache) {
                checkedPosition = this.checkCache;
            }
            else {
                return;
            }
        }
        ;
        // ... and reset depthTest to push handles to the front when zoomed in enough
        if (checkedPosition.handle && checkedPosition.handle.point) {
            checkedPosition.handle.point.disableDepthTestDistance = 10;
            this.ghostlineEnd(checkedPosition);
        }
        else if (checkedPosition.action && checkedPosition.action.billboard) {
            checkedPosition.action.billboard.disableDepthTestDistance = 10;
            this.ghostlineEnd(checkedPosition);
        }
        // this.turnHandleLabelsBackgroundOn();
    }
    dragHandle(external = false) {
        this.mouseDragMovements++;
        if (!this.inFlight) {
            if (this.debug) {
                console.log('mouse.drag MOVING, STARTING FIRST INITIALISATION ######', this.inFlight);
            }
            // this.turnHandleLabelsBackgroundOff();
            // temporary disable depthTest to help not get irratic movements when dragging a handle
            if (this.checkCache && this.checkCache.handle && this.checkCache.handle.point) {
                this.checkCache.handle.point.disableDepthTestDistance = 0;
                this.ghostlineStart(this.checkCache);
            }
            else if (this.checkCache && this.checkCache.action && this.checkCache.action.billboard) {
                this.checkCache.action.billboard.disableDepthTestDistance = 0;
                this.ghostlineStart(this.checkCache);
            }
            else if (external) {
                this.ghostlineStart(this.checkCache);
            }
        }
        this.inFlight = true;
        if (this.debug) {
            console.log('mouse.drag MOVING ######', this.inFlight);
        }
    }
    ghostlineStart(checkedPosition, useGhostlines = true) {
        if (!checkedPosition || !this.useGhostlines || !useGhostlines) {
            return;
        }
        if (this.debug) {
            console.log('%c shape_maker.service %c ghostlineStart()', Constants_1.Constants._orange, Constants_1.Constants._green, checkedPosition, useGhostlines);
        }
        // add our ghostlines to the map (basically a polyline with two or three points)
        let id = this.entityHelper.addEntity(global_1.AnnotationType.ghostline, {
            callback: this.ghostlineGetPositions.bind(this),
            positions: this.ghostlineGetPositions()
        }, this.annotation, 'shape-maker-ghostline');
        // we need two entities for coordinates, whether we show them or not
        this.ghostlabelOne = this.entityHelper.addEntity(global_1.AnnotationType.ghostlineLabel, { text: 'p1' }, this.annotation, 'shape-maker-ghostline');
        this.ghostlabelTwo = this.entityHelper.addEntity(global_1.AnnotationType.ghostlineLabel, { text: 'p2' }, this.annotation, 'shape-maker-ghostline');
        this.ghostLabelsOff();
        // turn on the infoboxes for these two labels
        // this.infoBoxes[this.ghostlabelOneIdx].show = true;
        // this.infoBoxes[this.ghostlabelTwoIdx].show = true;
        if (this.debug) {
            console.log('ghostline START ###########################################', this.inFlight, checkedPosition);
        }
        // setup the ghostline
        let positionsFrom = checkedPosition.action ? checkedPosition.action : checkedPosition.handle;
        // if there's a .new object, it means special rules
        if (checkedPosition.new) {
            positionsFrom = checkedPosition.new;
        }
        this.ghostline = { id: id, entity: positionsFrom, props: this.entityHelper.getEntityProperties(positionsFrom.id), positions: [], create_positions: [], cursor: null, p1: null, p2: null };
        if (checkedPosition.new) {
            this.ghostline.props = checkedPosition.props;
        }
    }
    ghostlineEnd(checkedPosition = null) {
        if (!this.useGhostlines) {
            return;
        }
        if (this.ghostline.id) {
            this.entityHelper.destroyEntity(this.ghostline.id);
        }
        if (this.ghostlabelOne) {
            this.entityHelper.destroyEntity(this.ghostlabelOne);
            // this.infoBoxes[this.ghostlabelOneIdx].show = false;
        }
        if (this.ghostlabelTwo) {
            this.entityHelper.destroyEntity(this.ghostlabelTwo);
            // this.infoBoxes[this.ghostlabelTwoIdx].show = false;
        }
        this.inFlight = false;
        this.ghostline = { id: null, entity: null, positions: [] };
        if (this.debug) {
            console.log('ghostline END ###########################################', this.inFlight);
        }
    }
    ghostLabel(who, state = true) {
        if (who) {
            let e = this.entityHelper.getEntity(who);
            if (e) {
                e.label.show = state;
            }
        }
    }
    ghostLabelsOff() {
        this.ghostLabel(this.ghostlabelOne, false);
        this.ghostLabel(this.ghostlabelTwo, false);
    }
    ghostLabelsOn() {
        this.ghostLabel(this.ghostlabelOne, true);
        this.ghostLabel(this.ghostlabelTwo, true);
    }
    // used in various measurement components directly
    updateGhostlinePositions(positions, cursor) {
        if (!this.useGhostlines) {
            return;
        }
        if (this.ghostline.create_positions && positions) {
            this.ghostline.create_positions = positions;
            this.ghostline.cursor = cursor;
            // if ( this.debug ) { console.log ( '%c shape_maker.service %c updateGhostlinePositions() arr[Cartesian3]], Cartesian3', Constants._orange, Constants._green, positions, cursor ); }
        }
    }
    ghostlineGetPositions() {
        if (!this.ghostline.id || !this.useGhostlines)
            return;
        // type of annotation
        const type = this.annotation ? this.annotation['annotationMode'] : null;
        // if ghostline hasn't been set up yet, just return an empty array
        if (!this.ghostline) {
            return [];
        }
        if (this.ghostline.props.typeRef == 'new_point') {
            let last = Constants_1.ArrayUtil.getLast(this.ghostline.create_positions);
            if (last) {
                let arr = [];
                // pick the last
                arr.push(last);
                // pick the current cursor position
                arr.push(this.ghostline.cursor);
                this.ghostpos = 1;
                this.ghostline.positions = arr;
            }
        }
        // initialise first-time running
        if (!this.ghostline.positions || this.ghostline.positions.length == 0) {
            if (this.ghostline.entity) {
                // let positions = this.entityHelper.getEntityProperty ( 'coords', this.ghostline)
                let shape = this.ghostline.props.shapeRef;
                let point = this.ghostline.props.pointRef;
                let arr = [];
                let shapeGroup = null;
                // if it's creation mode
                if (this.ghostline.props.typeRef == 'new_point') {
                    // moving mode
                }
                else {
                    if (shapeGroup = this.shape_entities.get(shape)) {
                        let max = shapeGroup.length;
                        let before = point;
                        let after = point + 1;
                        if (this.ghostline.props.typeRef == 'handle') {
                            before = point - 1;
                        }
                        if (type == global_1.AnnotationType.line) {
                            if (after > max) {
                                after = -1;
                            }
                        }
                        else {
                            if (before < 0) {
                                before = max;
                            }
                            if (after > max) {
                                after = 0;
                            }
                        }
                        let p1 = null;
                        let p2 = null;
                        let p3 = null;
                        shapeGroup.forEach((item) => {
                            let e = this.entityHelper.getEntity(item);
                            if (e && e.position) {
                                let p = this.entityHelper.getEntityProperties(item);
                                if (p.pointRef == before && before != -1 && e.position) {
                                    p1 = e.position._value;
                                }
                                if (p.pointRef == after && after != -1 && e.position) {
                                    p3 = e.position._value;
                                }
                            }
                        });
                        if (this.ghostline.entity.position) {
                            p2 = this.ghostline.entity.position._value;
                        }
                        if (p1) {
                            arr.push(p1);
                            //console.log ( 'OFF p1', before);
                            this.turnHandleLabelOff(before);
                        }
                        this.ghostpos = arr.push(p2) - 1;
                        if (p3) {
                            arr.push(p3);
                            //console.log ( 'OFF p3', after - 1);
                            this.turnHandleLabelOff(after - 1);
                        }
                        const s = 'color:blue;background-color:yellow;font-size:20px;';
                        if (this.debug) {
                            console.log('%c ghostlinePositions() ###########################################', s, shape, point, max, this.shape_entities);
                        }
                        if (this.debug) {
                            console.log('%c ghostlinePositions() ###########################################', s, before, after, p1, p2, p3, arr);
                        }
                    }
                }
                this.ghostline.positions = arr;
            }
            else {
                this.ghostline.positions = [];
            }
            // if ( this.debug ) { console.log ('%c ghostlinePositions() ###########################################', s, this.ghostpos, this.ghostline ); }
        }
        // make sure to always update the middle point / p2 with the handles position
        if (this.ghostpos !== null && this.ghostline && this.ghostline.entity && this.ghostline.entity.position) {
            this.ghostline.positions[this.ghostpos] = this.ghostline.entity.position._value;
        }
        // finally, if we've got positions, return them
        if (this.ghostline && this.ghostline.positions) {
            let precission = 2;
            if (this.annotation && this.annotation.project && this.annotation.project['number_precission']) {
                precission = this.annotation.project['number_precission'];
            }
            // more than one point means we calculate!
            if (this.ghostline.positions[0] && this.ghostline.positions[1]) {
                let calc = this.mapHelper.calculateLineInformation(this.ghostline.positions[0], this.ghostline.positions[1]);
                if (calc && calc.midpoint && calc.length) {
                    calc['precission'] = precission;
                    let e = this.entityHelper.getEntity(this.ghostlabelOne);
                    if (e) {
                        // e.label.showBackground = true;
                        e.label.text = this.createCalculatedText(calc);
                        e.position = calc.midpoint;
                    }
                }
            }
            // more than two points means we calculate another one!
            if (this.ghostline.positions[1] && this.ghostline.positions[2]) {
                let calc = this.mapHelper.calculateLineInformation(this.ghostline.positions[1], this.ghostline.positions[2]);
                if (calc && calc.midpoint && calc.length) {
                    calc['precission'] = precission;
                    let e = this.entityHelper.getEntity(this.ghostlabelTwo);
                    if (e) {
                        // e.label.showBackground = true;
                        e.label.text = this.createCalculatedText(calc);
                        e.position = calc.midpoint;
                    }
                }
            }
            // console.log (  '%c --', Constants._red, this.ghostline.positions );
            return this.ghostline.positions;
        }
    }
    // input an entity id, get back an object with properties
    getLabel(ent = null) {
        let e = this.entityHelper.getEntity(ent);
        if (e && e.position) {
            return {
                show: true,
                props: this.createProps(e.label.text._value),
                coord: e.position._value
            };
        }
        return { show: false };
    }
    // neither of these two are elegant, but until we write a better implementation, this is it for now
    getGhostlabelOne() {
        if (this.ghostlabelOne) {
            return this.getLabel(this.ghostlabelOne);
        }
        return null;
    }
    getGhostlabelTwo() {
        if (this.ghostlabelTwo) {
            return this.getLabel(this.ghostlabelTwo);
        }
        return null;
    }
    createProps(t) {
        let ret = [];
        let lines = t.split('\n');
        lines.forEach(l => {
            let s = l.split(':');
            ret.push({ key: s[0], value: s[1] });
        });
        return ret;
    }
}
exports.ShapeMaker = ShapeMaker;
